import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// Importing translation files
import Backend from 'i18next-http-backend'
import config from './config'

//i18N Initialization

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'enUS', //default language
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `${config.LanguageURL}/locales/{{lng}}/{{ns}}.json`,
        },
        react: {
            useSuspense: false,
        },
    })

export default i18n
